import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';

@Injectable()
export class NotesAnalytics extends AnalyticsBase {
  public readonly namespace = 'Note';
  public readonly requireViewContext = true;

  public trackNoteAdding(target: string) {
    this.track('AddNote', { target });
  }

  public trackFilterRecentNotes(target: string) {
    this.track('FilterRecentNotes', { target });
  }
}
